import {
  Elements,
  PaymentElement,
  AddressElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import environment from "../../env";
import { transformPrice } from "../CheckoutComponent/data";
import { PayBtn } from "../CheckoutComponent/PaymentInfo.styled";
import React, { useState } from "react";
import { useStore } from "@nanostores/react";
import {
  errorMessage,
  paymentInfo as $paymentInfoAtom,
} from "../../store/nanostore";
import { toast } from "react-toastify";
import { Alert, AlertTitle, AlertDescription } from "../Alert";
import { brandSettings } from "../../store/nanostore";
import PaypalHandler from "../PayPal";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
export const stripePromise = loadStripe(environment.publishableKey);
export default function StripeElementApp({
  clientSecret,
  children,
}: {
  clientSecret: string;
  children: any;
}) {
  const options = {
    // passing the client secret obtained from the server
    clientSecret,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <>
        <PaymentElement />
        <AddressElement options={{ mode: "billing" }} />
        {children}
        <StripeHandler />
      </>
    </Elements>
  );
}

export const StripeHandler = () => {
  const stripe = useStripe();
  const elements = useElements();
  const $paymentInfo = useStore($paymentInfoAtom);
  const $errorMessage = useStore(errorMessage);
  const [loading, setLoading] = useState(false);
  const $brandSettings = useStore(brandSettings);

  const handleError = (error: any) => {
    switch (error.type) {
      case "card_error":
      case "validation_error":
        return error.message;
      default:
        return "Could not process payment at this time";
    }
  };
  const handlePay = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    errorMessage.set("");
    if (!elements || !stripe) return;
    setLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/p/${$paymentInfo?.paymentIntent?.reference}/status`,
      },
    });
    const resp = handleError(error);
    errorMessage.set(resp);
    toast.error(resp);
    setLoading(false);
  };

  return (
    <>
      {$errorMessage && (
        <Alert variant="destructive">
          <AlertTitle>Error!</AlertTitle>
          <AlertDescription>{$errorMessage}</AlertDescription>
        </Alert>
      )}
      <PayBtn
        $active={!loading}
        onClick={handlePay}
        backgroundColor={$brandSettings?.primaryColor}
        color={$brandSettings?.secondaryColor}
      >
        {loading
          ? "Confirming..."
          : `Pay ${transformPrice($paymentInfo?.productPrice)}`}
      </PayBtn>
    </>
  );
};
